import { useTranslation } from "react-i18next";

import AuditSvg from "@/assets/common/other_icons/audit.svg?react";
import useSegmentEvent from "@/hooks/useSegmentEvent";

import BaseCard, { ActionButton } from "./BaseCard";

function CarbonCalculator() {
  const { t } = useTranslation(["communicate"]);
  const { sendSegmentEvent } = useSegmentEvent();

  return (
    <BaseCard
      title={t("communicate:carbonCalculator.title")}
      text={t("communicate:carbonCalculator.text")}
      Icon={AuditSvg}
    >
      <ActionButton
        to="/simulations"
        onClick={() => sendSegmentEvent("clic_calculatrice")}
      >
        {t("communicate:carbonCalculator.primaryAction")}
      </ActionButton>
    </BaseCard>
  );
}

export default CarbonCalculator;
